export default class Gelenk {
    /** 
     * Klasse für Gelenke
     * Es ist Grundsätzlich angedacht, dass die Gelenke auch Federsteifigkeiten haben können. 
     * In diesem Fall werden für die Werte nicht 0 sondern die entsprechenden Federsteifigkeiten angegeben.
     * 
     * Notiz: evtl. besser den Namen in Stabkopplungen anstelle von Gelenke ändern
     * @param {Gelenkliste} list 
     * @param {number} cN 
     * @param {number} cQ 
     * @param {number} cM 
     */
    constructor(list, cN, cQ, cM){
        this.Werte = [cN || 0, cQ || 0, cM || 0]
        this.Stabliste = []
        this.list = list || null
    }
    get number() {
        if(this.list) return this.list.indexOf(this)+1
        else return null
    }
    get name() { return 'Gelenk Nr. ' + this.number }
    get info() { return this.name + ' ∥: '+this.Werte[0] + '; ⊥: ' +this.Werte[1] + '; M:' +this.Werte[2]}
    add_Stabverknüpfung(stab){this.Stabliste.push(stab)}
    delete_Stabverknüpfung(stab){
        if (this.Stabliste.indexOf(stab)==-1) return console.log('Stab nicht in Liste')
        this.Stabliste.splice(this.Stabliste.indexOf(stab),1)}

    /**
     * Elementsteifigkeitsmatrix 6x6 bezogen auf globales System:
     * 
     *  zum Verständniss ist eine Herleitung der Elementsteifigkeitsmatrix z.B. in Jürgen Dankert "Technische Mechanik" Kapitel 18.2.4 zu finden.
     * 
     * 
     *  Folgende Abkürzungen werden in der Matrix verwendet:
     *  c=cos(Stabneigung)
     *  s=sin(Stabneigung) 
     *  β=(A*l²/I) 
     *        ┌                                                               ┐     ┌     ┐   ┌    ┐
     *        |   12s²+βc²  | (β-12)sc |-6ls  |-12s²-βc²  |-(β-12)sc  |-6ls   |     | u1  |   | U1 |
     *        |   (β-12)sc  | 12c²+βs² | 6lc  |-(β-12)sc  |-12c²-βs²  | 6lc   |     | v1  |   | V1 |
     *  EI/l³ |  -6ls       | 6lc      | 4l²  | 6ls       |-6lc       | 2l²   |  x  | p1  | = | M1 |
     *        |  -12s²-βc²  |-(β-12)sc | 6ls  | 12s²+βc²  | (β-12)sc  | 6ls   |     | u2  |   | U2 |
     *        |  -(β-12)sc  |-12c²-βs² |-6lc  | (β-12)sc  | 12c²+βs²  |-6lc   |     | v2  |   | V2 |
     *        |  -6ls       | 6lc      | 2l²  | 6ls       |-6lc       | 4l²   |     | p2  |   | M2 |
     *        └                                                               ┘     └     ┘   └    ┘
     * 
     *  Da die Elementmatrix an der Hauptdiagonalen gespiegelt ist können gibt es nur 18 Fälle. Es werden z.B. Position [1,1] gleich wie [4,4] berechnet.
     * 
     * @param {Integer} row 
     * @param {Interger} col 
     */
    Elementsteifigkeit_global(row, col, cStab, abs){
        if (!abs) abs = 10e10
        console.log(abs)
        const ts = cStab.tsin; const tc = cStab.tcos
        let Cn = this.Werte[0] == -1 ? abs*10e5 : this.Werte[0]
        let Cv = this.Werte[1] == -1 ? abs*10e5 : this.Werte[1]
        let Cm = this.Werte[2] == -1 ? abs*10e3 : this.Werte[2]          
        let Wert = 0
        switch (true){
            case (row == 1 && col == 1) || (row == 4 && col == 4):
                Wert = Cn*tc*tc+Cv*ts*ts
            break
            case (row == 1 && col == 2) || (row == 2 && col == 1):
                Wert = -Cn*ts*tc+Cv*tc*ts
            break
            case (row == 1 && col == 3) || (row == 3 && col == 1) || (row == 1 && col == 6) || (row == 6 && col == 1) || (row == 2 && col == 3) || (row == 3 && col == 2) || (row == 2 && col == 6) || (row == 6 && col == 2) || (row == 3 && col == 4) || (row == 4 && col == 3) || (row == 3 && col == 5) || (row == 5 && col == 3) || (row == 4 && col == 6) || (row == 6 && col == 4) || (row == 5 && col == 6) || (row == 6 && col == 5):
                Wert =  0
            break
            case (row == 1 && col == 4) || (row == 4 && col == 1):
                Wert =  -Cn*tc*tc-Cv*ts*ts
            break
            case (row == 1 && col == 5) || (row == 5 && col == 1):
                Wert =  +Cn*ts*tc-Cv*tc*ts
            break
            case (row == 2 && col == 2) || (row == 5 && col == 5):
                Wert =  Cn*ts*ts+Cv*tc*tc
            break
            case (row == 2 && col == 4) || (row == 4 && col == 2):
                Wert =  +Cn*ts*tc-Cv*tc*ts
            break
            case (row == 2 && col == 5) || (row == 5 && col == 2):
                Wert =  -Cn*ts*ts-Cv*tc*tc
            break
            case (row == 3 && col == 3) || (row == 6 && col == 6):
                Wert =  Cm
            break
            case (row == 3 && col == 6) || (row == 6 && col == 3):
                Wert =  -Cm
            break
            case (row == 4 && col == 5) || (row == 5 && col == 4):
                Wert =  -Cn*ts*tc+Cv*tc*ts
            break
        }
        return Wert
    }





}
/** 
 * Fachwerkgelenk wird als Standard in jedem System bereitgestellt. 
 * Es wird jedoch nicht in die Liste der Gelenke aufgenommen sondern ist nur über die Option Fachwerkstab zugänglich */
export const Fachwerkgelenk = new Gelenk(null, -1,-1,0);
